import { connect, ConnectedProps } from 'react-redux';
import { RootState } from 'src/store/rootReducer';
import { Box, Grid, makeStyles, createStyles } from '@material-ui/core';
import { colors } from 'design-system';
import PDFErrorMessage from './PDFErrorMessage';

const useStyles = makeStyles(() =>
  createStyles({
    boxContainer: {
      backgroundColor: colors.white,
      padding: 10,
      borderRadius: 10,
      height: '100%',
      boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.05)',
      maxHeight: 620,
    },
    fullHeight: {
      height: 'fit-content',
    },
  }),
);

export const PDFCard = ({
  isMobile,
  errorRequest,
  fileUrl,
}: Props): JSX.Element => {
  const classes = useStyles();

  return (
    <Grid item xs={12} md={7}>
      <Box className={classes.boxContainer}>
        {errorRequest ? (
          <PDFErrorMessage data-testid="pdf-error-message" />
        ) : (
          <div className={classes.fullHeight} data-testid="pdf-renderer">
            <iframe
              title="pdf-render"
              src={`${fileUrl}#navpanes=0`}
              width="100%"
              height={`${isMobile ? 400 : 600}px`}
            />
          </div>
        )}
      </Box>
    </Grid>
  );
};

export const mapStateToProps = (
  state: RootState,
): {
  fileUrl: string;
  errorRequest: boolean;
} => ({
  fileUrl: state.signature.fileUrl,
  errorRequest: state.signature.errorRequest,
});

const connector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props extends PropsFromRedux {
  isMobile?: boolean;
}
export default connector(PDFCard);
